import fromDtoToPerformance from 'dto/kpi/fromDtoToPerformance.dto';
import asArray from 'utils/arrays/asArray.util';

const createFromDtoToStylistsPerfInfo = (options) => {
  // NOTE: using a separate variable here so that the function will not be anonymous

  // noinspection UnnecessaryLocalVariableJS
  const fromDtoToStylistsPerfInfo = (dto) => {
    const { bgn, end } = options ?? {};

    const isForecast = dto?.results?.is_forecast;

    const performances = asArray(dto?.results?.business?.performance)
      .map(fromDtoToPerformance)
      .map((item) => ({ ...item, bgn, end }));

    // TODO: reorder the stylists/performances based on a field named order

    return { bgn, end, isForecast, performances };
  };

  return fromDtoToStylistsPerfInfo;
};

// noinspection JSUnusedGlobalSymbols
export default createFromDtoToStylistsPerfInfo;
